// extracted by mini-css-extract-plugin
module.exports = {"divider":"index-module--divider--3THuA","videos":"index-module--videos--2tKta","sam":"index-module--sam--1hAMB"};